// Plus-Symbol der Oeffner "Rolle hinzufuegen" und "Beziehung hinzufuegen"; stumm,
// der Name steht am Knopf. Eine Definition fuer beide Abschnitte.

import type { ReactElement } from 'react';

export function PlusSymbol(): ReactElement {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
      <path d="M12 5v14M5 12h14" />
    </svg>
  );
}

/** Verknuepfen-Symbol fuer "Bestehenden Kontakt zuordnen"; stumm wie das Plus. */
export function VerknuepfenSymbol(): ReactElement {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 14a4 4 0 0 0 5.66 0l3-3a4 4 0 0 0-5.66-5.66l-1 1M14 10a4 4 0 0 0-5.66 0l-3 3a4 4 0 0 0 5.66 5.66l1-1" />
    </svg>
  );
}

/**
 * Escape schliesst ein Anlegeformular wie "Abbrechen" -- ausser es gehoert einer
 * offenen Auswahlliste: dann schliesst es nur diese (Fluent-Dropdown, aria-expanded).
 */
export function beiEscapeSchliessen(
  event: { readonly key: string; readonly defaultPrevented: boolean; readonly target: EventTarget; stopPropagation: () => void },
  schliessen: () => void,
): void {
  if (event.key !== 'Escape' || event.defaultPrevented) {
    return;
  }
  const ziel = event.target;
  if (ziel instanceof HTMLElement && ziel.getAttribute('aria-expanded') === 'true') {
    return;
  }
  event.stopPropagation();
  schliessen();
}
